export interface DocumentVersionViewModel {
    fileName: string;
    version: number;
    created: Date;
    documentId: string;
    documentVersionId: string;
    dataId: string;
    link: string;
}

export class DocumentBaseSaveModel {
    fileName?: string;
    link?: string;
    uploadId?: string;

    constructor() {
        this.link = "";
    }
}
